<template>
  <div class="image-counters-page">
    <PopupClickArea @openPopup="popup(true)">
      See the devices we compare
    </PopupClickArea>
    <div class="counters">
      <ImageCounter
        v-for="(option, index) in data.options"
        :key="index"
        v-model="answer[option.value]"
        class="align-items-center"
        :option="option"
        :theme="option.theme"
        @input="updateAnswer"
      />
      <span
        class="counters__unsure-link"
        @click="skipQuestion"
      >{{ data.skipQuestionMessage }}</span>
    </div>
    <transition name="slide-up">
      <PopupBox
        v-if="showPopup"
        class="popup-box"
        :title="'The cloud phone devices Bionic compares'"
        :sub-title="'You can choose exact phones when you talk to our expert'"
        @closePopup="popup(false)"
      >
        <div class="popup-box__wrapper">
          <div class="handsets">
            <ProductCard
              v-for="(item, i) in products"
              :key="i"
              class="handsets__product"
            >
              <HandsetProduct :product="item" />
            </ProductCard>
          </div>
        </div>
      </PopupBox>
    </transition>
  </div>
</template>

<script>
import ImageCounter from '@/components/question/inputs/ImageCounter'
import PopupClickArea from '@/components/ui/PopupClickArea'
import PopupBox from '@/components/ui/PopupBox'
import ProductCard from '@/components/ui/cards/ProductCard'
import HandsetProduct from '@/components/products/HandsetProduct'
import handSetProducts from '@/assets/data/products/handSetProducts'
import Utag from '@/mixins/Utag'

export default {
  name: 'ImageCounters',
  components: {
    ImageCounter,
    PopupClickArea,
    PopupBox,
    ProductCard,
    HandsetProduct
  },
  mixins: [Utag],
  props: {
    data: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showPopup: false,
      answer: {},
      products: handSetProducts
    }
  },
  mounted () {
    if (this.value && this.value.result) this.answer = this.value.result
    this.data.options.forEach((option) => {
      if (!(option.value in this.answer)) this.answer[option.value] = 0
    })
  },
  methods: {
    updateAnswer (input) {
      this.$emit('input', { result: this.answer })
    },
    skipQuestion () {
      this.updateTracking(this.data.trackingSkipQ)
      Object.keys(this.answer).forEach((option) => {
        this.answer[option] = 0
      })
      this.updateAnswer()
      this.$emit('skippedQuestion', true, this.data.questionId)
      this.$emit('autoprogress', true)
    },
    popup (popupBoolean) {
      this.showPopup = popupBoolean
      if (popupBoolean) {
        this.updateTracking(this.data.tracking)
      }
    },
    updateTracking (trackingData) {
      if (trackingData) {
        this.generalTracking(trackingData)
      }
    }
  }
}
</script>
<style lang="scss">

.image-counters-page {
.popup-box {

  &__content {
      @media(max-width: $screen-md) {
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
      }
  }
}
}
</style>
<style lang="scss" scoped>

.counters {
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: 720px) {
    flex-direction: row;
    margin: 0 auto;
    height: auto;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-width: unset;
    width: unset;
  }

  &__unsure-link {
    cursor: pointer;
    color: $question-subtitle-color;
    font-size: 14px;
    letter-spacing: -0.56px;
    line-height: 20px;
    text-decoration: underline;
    margin-right: auto;
    margin-left: auto;

    @media (min-width: 720px) {
      margin: 30px auto 0 auto;
    }
  }
}

.popup-box {

  &__content {
      @media(max-width: $screen-md) {
        max-width: 300px;
        margin-left: auto;
        margin-right: auto;
      }
  }
  &__wrapper {

    @media (max-width: $screen-md) {
      max-width: 300px;
      margin-left: auto;
      margin-right: auto;
    }

  }
}

.handsets {
  display: flex;
  flex-wrap: wrap;

  &__product {
    margin-right: 8px;
    margin-bottom: 8px;

    @media (min-width: $screen-lg) {
      margin-right: 24px;
      margin-bottom: 24px;
    }
  }
}

.handsets div:nth-child(4n) {
  @media (min-width: $screen-lg) {
    margin-right: 0;
  }
}
</style>
